import { neutral, success as _success, error as _error, brand, brandAlt, } from '../global';
export const brandText = {
    primary: neutral[100],
    supporting: brand[800],
    success: _success[500],
    error: _error[500],
    ctaPrimary: brand[400],
    ctaSecondary: neutral[100],
    ctaTertiary: neutral[100],
    anchorPrimary: neutral[100],
    anchorPrimaryHover: brandAlt[400],
    userInput: neutral[100],
    inputLabel: neutral[100],
    inputLabelSupporting: brand[800],
};
//# sourceMappingURL=brand.js.map
